import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <rect key='0' fill='#00B90F' x='2' y='2' className='st0' width='20' height='20' />,
    <path key='1' fill='#000000' d='M1,1v22h22V1H1z M3,21V3h18v18H3z' />,
  ],
  'TransportConditionSpeed'
);

const TransportSquareIcon = function (props) {
  return (
    <SvgIcon
      sx={{
        rect: {
          fill: props.color,
        },
      }}
      {...props}
    />
  );
};

export default memo(TransportSquareIcon);
